import GuildPresetsContract from 'decentralized/contracts/GuildPresetsContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {
    NewPreset2,
    PresetTag,
    PresetSample,
    PresetInstrumentType
} from 'decentralized/EthereumEvents.js';
import {web3} from 'decentralized/web3.js';

const contract = new GuildPresetsContract();

export const getPresetTags = async (type) => {
    let instQuery= new BackendQuery(contract.contractAddress)
        .from(PresetInstrumentType)
        .select('contentHash')
        .where('instrumentType', type);

    let instResults = (await instQuery.executeQuery())
        .map(x => x.contentHash);

    let query = new BackendQuery(contract.contractAddress)
        .from(PresetTag)
        .select('tag')
        .whereIn('contentHash', instResults);

    let results = await query.executeQuery();
    let x = Array.from(new Set(results.map(x => x.tag)));
    x.sort();
    return x;
}
